import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import {i18n2} from 'features/i18n/i18n';
import React, {useEffect, useState} from 'react';
import {Redirect} from 'react-router-dom';
import useLoadNotification from '../hooks/useLoadNotification';
import moment from 'moment';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '360px',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    inline: {
      display: 'inline',
    },
  }),
);

function Notification() {
  const loadNotification = useLoadNotification('notification', 'undefined');
  const [data, setData] = React.useState([]);

  useEffect(() => {
    loadNotification()
      .then(({data}) => {
        if (data != null) {
          setData(data);
        }
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const props = {
    active: false,
    path: '',
    iD_Course: [],
    iD_Instance: [],
    modality: 0,
    expired: false,
  };

  const [redirect, setRedirect] = useState(props);

  const formatDate = (value: any) => {
    const today = new Date();
    const date_vig = new Date(value);

    if (date_vig.getFullYear() < today.getUTCFullYear()) {
      return i18n2._('Se encuentra vencido');
    }

    if (date_vig.getFullYear() > today.getUTCFullYear()) {
      const myMonth = date_vig.getMonth() + 1;
      return (
        i18n2._('Vence el: ') +
        date_vig.getDate() +
        '/' +
        myMonth +
        '/' +
        date_vig.getFullYear()
      );
    }

    if (
      date_vig.getDate() === today.getUTCDate() &&
      date_vig.getMonth() === today.getUTCMonth()
    ) {
      return i18n2._('Vence hoy');
    }
    if (date_vig.getMonth() < today.getUTCMonth()) {
      return i18n2._('Se encuentra vencido');
    }
    if (date_vig.getMonth() === today.getUTCMonth()) {
      if (date_vig.getDate() > today.getUTCDate()) {
        const diffDate = date_vig.getDate() - today.getUTCDate();
        if (diffDate === 1) {
          return i18n2._('Vence mañana');
        } else {
          return i18n2._('Vence en ') + diffDate + i18n2._(' días');
        }
      } else {
        return i18n2._('Se encuentra vencido');
      }
    } else {
      const myMonth = date_vig.getMonth() + 1;
      return (
        i18n2._('Vence el: ') +
        date_vig.getDate() +
        '/' +
        myMonth +
        '/' +
        date_vig.getFullYear()
      );
    }
  };

  const classes = useStyles();
  return (
    <>
      <List
        className={classes.root}
        component="nav"
        aria-labelledby="nested-list-subheader">
        {data.slice(0, 4).map((x: any) => {
          let modality;
          if (x.modality === 0) {
            modality = 'Online';
          } else if (x.modality === 1) {
            modality = 'Tablet';
          } else {
            modality = i18n2._('Papel');
          }
          const expirationDate = moment(x.expiration_Date, 'YYYY-MM-DD');
          var current = moment().startOf('day');
          return (
            <>
              <ListItem
                button
                alignItems="flex-start"
                key={x.iD_Instance}
                className={classes.nested}
                onClick={() => {
                  setRedirect({
                    active: true,
                    path: './Capacitation',
                    iD_Course: x.iD_Course,
                    iD_Instance: x.iD_Instance,
                    modality: x.modality,
                    expired:
                      moment.duration(expirationDate.diff(current)).asDays() <
                      0,
                  });
                }}>
                <ListItemText
                  primary={x.name}
                  secondary={
                    <React.Fragment>
                      <Typography
                        component="span"
                        variant="body2"
                        color="textPrimary"
                        className={classes.inline}>
                        {i18n2._('Modalidad: ') + modality}
                        <br></br>
                      </Typography>
                      {formatDate(x.expiration_Date)}
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider />
            </>
          );
        })}
        {data.length === 0 && (
          <>
            <div style={{paddingLeft: '1vh'}}>
              {i18n2._('No hay notificaciones.')}
            </div>
          </>
        )}
        {data.length >= 5 && (
          <>
            <ListItem
              button
              alignItems="flex-start"
              key={2}
              className={classes.nested}
              onClick={() => {
                setRedirect({
                  active: true,
                  path: './Dashboard',
                  iD_Course: [],
                  iD_Instance: [],
                  modality: 0,
                  expired: false,
                });
              }}>
              <ListItemText primary={i18n2._('Ver todos')} />
            </ListItem>
          </>
        )}
      </List>
      {redirect.active && redirect.modality === 0 ? (
        <Redirect
          to={{
            pathname: redirect.path,
            state: {
              iD_Course: redirect.iD_Course,
              iD_Instance: redirect.iD_Instance,
              modality: redirect.modality,
              expired: redirect.expired,
            },
          }}
        />
      ) : (
        <></>
      )}
    </>
  );
}

export default Notification;
